import { render, staticRenderFns } from "./on.vue?vue&type=template&id=63c140b3&"
import script from "./on.vue?vue&type=script&lang=js&"
export * from "./on.vue?vue&type=script&lang=js&"
import style0 from "./on.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "on.vue"
export default component.exports